// Portrait lab page: photo -> check -> customer's choices -> first try -> (try again -> pick one of two) -> done.
// Talks to the hystoriq-lab Worker (window.LAB from config.js, which is generated at deploy and not in git).
(function () {
  'use strict';
  var TEMPLATE = 'cowboy-trex'; // changed by the style picker in step 1
  var MAX_ROLL = 6;        // same values as tools/face-lab/rules.mjs
  var CROP_EYES = 5, CROP_EYE_Y = 0.42;
  var LONG_SIDE = 1536;    // photos are resized in the browser before upload
  var MIN_SHORT = 512;     // small photos and crops are enlarged to at least this (Runware: reference images >= 128 px)
  var EXPECTED_SECONDS = 45;

  // Shown while the portrait is painted, one every few seconds, in the costume's own world.
  // Cowboy lines chosen by Giacomo on 27/09/2026; the others written on 29/09/2026 in the same spirit.
  var WAIT_LINES = {
    'cowboy-trex': [
      'Dusting off the 1890s camera...',
      'Saddling up your dinosaur...',
      "Fitting your hat. It's a little big, adjusting...",
      'Mixing the sepia: two parts coffee, one part nostalgia...',
      'Teaching the T-Rex your good side...',
      'Almost there. The T-Rex says this is your best angle.',
    ],
    aviator: [
      'Warming up the Spitfire...',
      'Polishing the flying goggles...',
      'Checking the oxygen mask. Deep breaths...',
      'Mixing the black and white: equal parts grit and glory...',
      'Asking the ground crew to find your good side...',
      'Almost there. Cleared for takeoff.',
    ],
    golf: [
      'Raking the bunker...',
      'Brushing the tweed cap...',
      'Choosing the right club. Probably the putter...',
      'Mixing the sepia: two parts 1920s, one part fairway...',
      'Asking the caddie to find your good side...',
      'Almost there. Fore!',
    ],
    longhorn: [
      'Saddling up the longhorn...',
      'Measuring the horns. Still growing...',
      'Dusting off the hat...',
      'Clearing Main Street for the photographer...',
      'Asking the bull to look this way. He is thinking about it...',
      'Almost there. Hold that pose, partner.',
    ],
    'civil-war': [
      'Brushing the dust off the greatcoat...',
      'Polishing every one of the brass buttons...',
      'Tying the sash. Twice...',
      'Holding still for the long exposure. Very still...',
      'Asking the photographer to steady the glass plate...',
      'Almost there. Chin up, General.',
    ],
    bigfoot: [
      'Asking Bigfoot to hold still. He is shy...',
      'Brushing the pine needles out of his fur...',
      'Lacing up the expedition boots...',
      'Measuring the footprints. Size 24...',
      'Waiting for the fog to lift off the pines...',
      'Almost there. Nobody will believe this photo.',
    ],
    'wwii-general': [
      'Pressing the uniform. Razor-sharp creases...',
      'Polishing the eagle on the cap...',
      'Straightening the tie. Regulation length...',
      'Setting up the studio lights...',
      'Holding still for the photographer. At ease...',
      'Almost there. Eyes front, soldier.',
    ],
    'cowboy-portrait': [
      'Shaping the brim of the hat...',
      'Knotting the bandana. Loose, like a real cowhand...',
      'Dusting off the leather vest...',
      'Lighting the studio with a single window...',
      'Asking the photographer to count to three...',
      'Almost there. Howdy, partner.',
    ],
    soldier: [
      'Strapping on the helmet...',
      'Cleaning the rifle. Twice, by the book...',
      'Rolling up the field jacket sleeves...',
      'Waiting for the smoke to clear...',
      'Asking the war correspondent for one more shot...',
      'Almost there. Hold the line.',
    ],
    sailor: [
      'Knitting the wool sweater. Extra thick...',
      'Buckling the braces...',
      'Checking the tide tables...',
      'Waiting for the fog to roll off the harbour...',
      'Asking the gulls to keep it down...',
      'Almost there. Steady as she goes.',
    ],
    gangster: [
      'Pressing the pinstripes...',
      'Tilting the fedora just so...',
      'Folding the pocket square...',
      'Bringing the car round to the curb...',
      'Telling the photographer to keep it quiet...',
      'Almost there. Nobody talks.',
    ],
    'trophy-fish': [
      'Combing the moustache...',
      'Holding the bass at arm\'s length. Looks bigger that way...',
      'Pulling down the studio backdrop...',
      'Loading 1970s film...',
      'Asking the fish to say cheese...',
      'Almost there. It was THIS big.',
    ],
    headless: [
      'Unscrewing the head. Carefully...',
      'Setting it on the little table...',
      'Straightening the bow tie on an empty collar...',
      'Telling the photographer not to faint...',
      'Holding very, very still...',
      'Almost there. Keep your head.',
    ],
    'bigfoot-victorian': [
      'Brushing the bowler hat...',
      'Pinning the holly on Bigfoot. He insisted...',
      'Plumping the cushions on the armchair...',
      'Asking Bigfoot to keep his paw still...',
      'Waiting for the flash powder to settle...',
      'Almost there. Merry Christmas from the woods.',
    ],
    highland: [
      'Tuning the bagpipes. Apologies to the neighbors...',
      'Pleating the kilt...',
      'Waxing the mustache...',
      'Mixing the oils: two parts heather, one part Highland mist...',
      'Asking the old castle to find your good side...',
      'Almost there. The paint is nearly dry.',
    ],
  };
  // In reserve (cowboy): "Asking the T-Rex to hold still. He won't.", 'Polishing the spurs...',
  // "Negotiating with the dinosaur's agent...", 'Adding exactly the right amount of Wild West dust...'

  var $ = function (id) { return document.getElementById(id); };
  var state = {};

  // ---------- funnel events (Giacomo, 09/10/2026: see where people stop) ----------
  // Every step of the lab is announced to whatever is listening: Shopify customer events (custom pixels, GA4 through
  // the Google channel), Microsoft Clarity (funnels and recordings) and window.dataLayer. Nothing personal is sent:
  // the step, the costume and, where it matters, the price. Trackers load only with the visitor's consent.
  function track(name, props) {
    var data = { costume: TEMPLATE };
    for (var k in (props || {})) data[k] = props[k];
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('hq_' + name, data); } catch (e) {}
    try { if (typeof window.clarity === 'function') { window.clarity('event', 'hq_' + name); window.clarity('set', 'costume', data.costume); } } catch (e) {}
    try { var d = { event: 'hq_' + name }; for (var j in data) d[j] = data[j]; (window.dataLayer = window.dataLayer || []).push(d); } catch (e) {}
    // The OpenAI Ads pixel events (items_added, checkout_started) were removed on 27/10/2026 with the pixel itself:
    // the ChatGPT ads stopped on 19/10. To bring them back, see git history before commit "OpenAI pixel off".
  }
  window.hqTrack = track;
  // The ChatGPT ad click id, kept by the OpenAI pixel in its first-party cookie once the visitor allows marketing.
  // Written onto the cart as _oppref, so the lab server can credit the purchase to the ad (Conversions API).
  function opprefCookie() { var m = document.cookie.match(/(?:^|;\s*)__oppref=([^;]+)/); return m ? decodeURIComponent(m[1]) : ''; }

  // ---------- who is this: a device id and, once signed in, a session token (both in localStorage) ----------
  function stored(key, value) {
    try { if (value === undefined) return localStorage.getItem(key); if (value === null) localStorage.removeItem(key); else localStorage.setItem(key, value); } catch (e) { return null; }
    return value;
  }
  function newId() { return (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random().toString(16).slice(2) + '0000000000'; }
  var visitor = stored('hq-visitor') || stored('hq-visitor', newId());
  var account = { signedIn: false, credits: 0 };

  // ---------- anti-bot: Cloudflare Turnstile ----------
  // The widget runs only when asked (execution: 'execute'). Most people never see it; in doubtful cases it shows
  // a single "verify you are human" box. Without a site key configured the page simply skips it.
  var tsWidget = null, tsWaiting = null;
  function turnstileToken() {
    var key = window.LAB.turnstile;
    if (!key) return Promise.resolve('');
    return new Promise(function (resolve, reject) {
      function run() {
        tsWaiting = { resolve: resolve, reject: reject };
        if (tsWidget === null) {
          tsWidget = window.turnstile.render('#human', {
            sitekey: key, execution: 'execute', appearance: 'interaction-only', theme: 'dark',
            callback: function (t) { var w = tsWaiting; tsWaiting = null; if (w) w.resolve(t); },
            'error-callback': function () { var w = tsWaiting; tsWaiting = null; if (w) w.reject(new Error('The human check could not load. Please reload the page.')); },
          });
        } else { window.turnstile.reset(tsWidget); }
        window.turnstile.execute(tsWidget);
      }
      if (window.turnstile) return run();
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true; s.onload = run; s.onerror = function () { reject(new Error('The human check could not load. Please reload the page.')); };
      document.head.appendChild(s);
    });
  }

  // Protected calls get a fresh Turnstile token first.
  var PROTECTED = { '/api/check': 1, '/api/login': 1 };
  function api(path, body) {
    if (PROTECTED[path]) return turnstileToken().then(function (t) { return send(path, body, t); });
    return send(path, body, '');
  }

  function send(path, body, human) {
    var headers = { 'x-lab-key': window.LAB.key, 'x-visitor': visitor };
    if (human) headers['x-turnstile'] = human;
    var C = window.HQ_CUSTOMER;
    if (C) { headers['x-shopify-customer'] = C.id + '.' + C.ts + '.' + C.sig; headers['x-shopify-email'] = encodeURIComponent(C.email); }
    else { var session = stored('hq-session'); if (session) headers['x-session'] = session; }
    if (body) headers['Content-Type'] = 'application/json';
    return fetch(window.LAB.api + path, { method: body ? 'POST' : 'GET', headers: headers, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) {
        // A server hiccup can answer with an HTML error page: the visitor saw "Unexpected token '<'..." (review of
        // 27/10/2026). Anything that is not our JSON becomes a plain "please try again".
        return r.json().catch(function () { return null; }).then(function (j) {
          if (!j) throw new Error('Something went wrong on our side. Please try again in a minute.');
          if (!r.ok) { var err = new Error(j.error || 'Something went wrong.'); err.need = j.need; err.suggestion = j.suggestion; throw err; }
          return j;
        });
      }, function () { throw new Error('We could not reach the portrait lab. Please check your connection and try again.'); });
  }

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; }
  function button(label, cls, onClick) { var b = el('button', 'btn ' + (cls || ''), label); b.type = 'button'; b.addEventListener('click', onClick); return b; }
  function clear(node) { node.textContent = ''; return node; }
  // No "Save image" on the portrait previews (they come as data: images), with the mouse or by dragging (Giacomo,
  // 11/10/2026, instead of the watermark); lab.css stops the long press on phones. A screenshot stays possible.
  function isPreview(t) { return t && t.tagName === 'IMG' && /^data:/.test(t.getAttribute('src') || ''); }
  document.addEventListener('contextmenu', function (e) { if (isPreview(e.target)) e.preventDefault(); });
  document.addEventListener('dragstart', function (e) { if (isPreview(e.target)) e.preventDefault(); });
  // Shakes a box to be ticked, on every try (Giacomo, 10/10: once was easy to miss on a phone).
  function nudge(node) { node.classList.remove('lab-nudge'); void node.offsetWidth; node.classList.add('lab-nudge'); }

  // Resize in the browser (and honour the phone's EXIF rotation) so uploads stay small and every photo is a JPEG.
  // Two ways to open the photo: createImageBitmap, then an <img> (some in-app browsers, e.g. Instagram on Android,
  // refused files the first way). Rejects with 'unreadable' if neither can: before 19/10/2026 that failure was silent
  // and a visitor uploaded the same photo 8 times with nothing happening.
  function decodePhoto(file) {
    return createImageBitmap(file, { imageOrientation: 'from-image' }).catch(function () {
      return new Promise(function (resolve, reject) {
        var url = URL.createObjectURL(file), img = new Image();
        img.onload = function () { resolve(img); setTimeout(function () { URL.revokeObjectURL(url); }, 0); };
        img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('unreadable')); };
        img.src = url;
      });
    }).then(function (src) {
      var w = src.naturalWidth || src.width, h = src.naturalHeight || src.height; // an <img> reports natural sizes
      if (!w || !h) throw new Error('unreadable');
      return { src: src, width: w, height: h };
    });
  }
  function loadPhoto(file) {
    return decodePhoto(file).then(function (pic) {
      var bmp = pic;
      var scale = Math.min(1, LONG_SIDE / Math.max(bmp.width, bmp.height));
      // Small photos (allowed with a warning since 06/10/2026) are enlarged to MIN_SHORT: Runware refuses reference
      // images narrower than 128 px. The size rules still read the original size (originalWidth/Height).
      if (Math.min(bmp.width, bmp.height) * scale < MIN_SHORT) scale = MIN_SHORT / Math.min(bmp.width, bmp.height);
      var c = document.createElement('canvas');
      c.width = Math.round(bmp.width * scale); c.height = Math.round(bmp.height * scale);
      var g = c.getContext('2d');
      g.imageSmoothingQuality = 'high';
      g.fillStyle = '#ffffff'; g.fillRect(0, 0, c.width, c.height); // cut-out photos: white, not black, behind them
      g.drawImage(bmp.src, 0, 0, c.width, c.height);
      return { canvas: c, originalWidth: bmp.width, originalHeight: bmp.height };
    });
  }

  // Head-and-shoulders crop for the generator: a square of CROP_EYES x the eye distance, eyes at CROP_EYE_Y of
  // its height, rotated around the eyes by minus the tilt when the head leans more than MAX_ROLL degrees.
  function prepared(canvas, eyes, roll) {
    var side = Math.min(Math.round(eyes.eyes * CROP_EYES), canvas.width, canvas.height);
    var zoom = Math.max(1, MIN_SHORT / side); // never under Runware's 128 px minimum (06/10/2026: a 137x170 photo failed)
    var c = document.createElement('canvas');
    c.width = c.height = Math.round(side * zoom);
    var g = c.getContext('2d');
    g.imageSmoothingQuality = 'high';
    g.scale(zoom, zoom);
    g.fillStyle = '#ffffff'; g.fillRect(0, 0, side, side);
    g.translate(side / 2, side * CROP_EYE_Y);
    if (Math.abs(roll) > MAX_ROLL) g.rotate((-roll * Math.PI) / 180);
    g.drawImage(canvas, -eyes.cx, -eyes.cy);
    return c.toDataURL('image/jpeg', 0.92);
  }

  // ---------- the photo on screen ----------

  function showPhoto(src) {
    var box = clear($('picked'));
    box.className = 'lab-preview';
    var img = el('img'); img.src = src; img.alt = 'Your photo';
    box.appendChild(img); box.hidden = false;
    // A way out at any moment, good photo included (Giacomo, 11/10/2026): back to the empty box, gallery or selfie.
    var x = el('button', 'lab-remove'); x.type = 'button'; x.setAttribute('aria-label', 'Remove this photo');
    x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" d="M6 6l12 12M18 6 6 18"/></svg>';
    x.addEventListener('click', removePhoto);
    box.appendChild(x);
  }

  function removePhoto() {
    checkSeq++; // a check still running for this photo must not write its answer afterwards
    track('photo_removed');
    clear($('check')).hidden = true; clear($('picked')).hidden = true;
    $('photo').value = ''; if ($('selfie')) $('selfie').value = '';
  }

  // Several people: a round button over each face. The customer keeps seeing their own photo; the chosen face
  // stays lit and the others are dimmed. The crop with the others covered goes to the check behind the scenes.
  function drawFaces(faces) {
    var box = $('picked'), c = state.canvas;
    box.classList.add('lab-faces');
    faces.forEach(function (f, i) {
      var b = el('button', 'lab-face'); b.type = 'button';
      b.setAttribute('aria-label', 'Use face ' + (i + 1));
      place(b, f, c);
      b.addEventListener('click', function () { chooseFace(f, faces); });
      box.appendChild(b);
    });
  }

  function place(node, f, c) {
    node.style.left = (100 * f.x / c.width) + '%'; node.style.top = (100 * f.y / c.height) + '%';
    node.style.width = (100 * f.w / c.width) + '%'; node.style.height = (100 * f.h / c.height) + '%';
  }

  function markChosen(f) {
    var box = $('picked'), c = state.canvas;
    box.querySelectorAll('.lab-face').forEach(function (b) { b.remove(); });
    box.classList.remove('lab-faces'); box.classList.add('lab-chosen');
    var ring = el('span', 'lab-ring'); place(ring, f, c);
    box.appendChild(ring);
  }

  function chooseFace(f, faces) {
    var c = state.canvas, ratio = state.originalWidth / c.width;
    markChosen(f);
    // Tighter than a normal photo: 2.2 times the face, so little of anyone else gets in.
    var side = Math.min(Math.round(Math.max(f.w, f.h) * 2.2), Math.max(c.width, c.height));
    var cx = f.x + f.w / 2, cy = f.y + f.h * 0.55;
    var crop = document.createElement('canvas'); crop.width = side; crop.height = side;
    var g = crop.getContext('2d');
    g.fillStyle = '#ffffff'; g.fillRect(0, 0, side, side);
    var dx = Math.round(side / 2 - cx), dy = Math.round(side / 2 - cy);
    g.drawImage(c, dx, dy);
    // Cover the other people, never reaching into the chosen face.
    faces.forEach(function (o) {
      if (o === f) return;
      g.save();
      g.beginPath(); g.rect(0, 0, side, side);
      g.ellipse(f.x + f.w / 2 + dx, f.y + f.h / 2 + dy, f.w * 0.62, f.h * 0.62, 0, 0, 2 * Math.PI);
      g.clip('evenodd');
      g.fillStyle = '#ffffff';
      g.beginPath(); g.ellipse(o.x + o.w / 2 + dx, o.y + o.h / 2 + dy, o.w * 0.75, o.h * 0.75, 0, 0, 2 * Math.PI); g.fill();
      g.restore();
    });
    runCheck({ canvas: crop, originalWidth: Math.round(side * ratio), originalHeight: Math.round(side * ratio), chosen: true });
  }

  // ---------- check ----------

  function showCheck(res) {
    var box = clear($('check'));
    box.hidden = false; box.className = 'lab-message';
    var serious = (res.warnings || []).filter(function (w) { return w.serious; });
    var minor = (res.warnings || []).filter(function (w) { return !w.serious; });
    var list = function (items, cls) { var ul = el('ul'); items.forEach(function (w) { ul.appendChild(el('li', cls, w.message)); }); return ul; };
    var actions = el('div', 'lab-actions');

    if (res.verdict === 'choose' && (res.faces || []).length) {
      box.appendChild(el('p', 'lead', res.message));
      drawFaces(res.faces);
      actions.appendChild(button('Upload another photo', 'btn-line', pickAgain));
    } else if (res.verdict === 'reject' || res.verdict === 'choose') {
      box.classList.add('bad');
      box.appendChild(el('p', 'lead', res.message));
      actions.appendChild(button('Upload another photo', '', pickAgain));
    } else if (res.verdict === 'confirm_age') {
      box.appendChild(el('p', 'lead', res.message));
      // A lighter tone (Giacomo, 17/10/2026): the old "Is the person in this photo 18 or older?" read like a control
      // and a visitor stopped there. Adults only stays; the question just sounds like a quick check.
      actions.appendChild(button('Yes, he is', '', function () { state.accepted.push('yes_18_plus'); startGen(); }));
      actions.appendChild(button('Use another photo', 'btn-line btn-sm', pickAgain));
    } else if (res.verdict === 'confirm') {
      box.appendChild(el('p', 'lead', res.message));
      // Two groups, each with its label (Giacomo, 6 Oct): gold = changes the likeness, grey = only good to know.
      box.appendChild(el('p', 'warn-label serious', 'Affects the likeness'));
      box.appendChild(list(serious, 'serious'));
      if (minor.length) { box.appendChild(el('p', 'warn-label', 'Good to know')); box.appendChild(list(minor)); }
      actions.appendChild(button('Continue with this photo', '', function () { state.accepted.push('continue'); startGen(); }));
      actions.appendChild(button('Upload another photo', 'btn-line', pickAgain));
    } else {
      box.appendChild(el('p', 'lead', res.verdict === 'ok' ? 'Great photo. Ready when you are.' : 'This photo works. A couple of notes:'));
      if (minor.length) box.appendChild(list(minor));
      actions.appendChild(button('Create my portrait', '', startGen));
    }
    box.appendChild(actions);
  }

  // Step 1: the costume. Switching after a photo is checked is fine: the next portrait uses the new costume.
  document.querySelectorAll('.lab-pick-style').forEach(function (b) {
    b.addEventListener('click', function () {
      TEMPLATE = b.getAttribute('data-template');
      document.querySelectorAll('.lab-pick-style').forEach(function (o) { o.setAttribute('aria-checked', String(o === b)); });
    });
  });

  function pickAgain() { if (!hasCredit()) return outOfCredits(); $('photo').value = ''; $('photo').click(); }

  // ---------- credits and pop-ups ----------
  var historyLoaded = false;
  function hasCredit() { return account.credits > 0 && !account.blocked; }

  function showMe(m) {
    if (m) account = m;
    // One run of text inside the line (Giacomo, 06/10: as separate flex items the dots floated and the email
    // broke into columns); "· Sign out" / "· Sign in" never splits from its dot.
    var box = clear($('credits'));
    if (account.blocked) { box.appendChild(el('span', 'lab-credits-bad', 'Access blocked.')); return; }
    var line = el('span', 'lab-credits-text'); box.appendChild(line);
    var n = account.credits;
    line.appendChild(el('b', '', account.signedIn ? n + (n === 1 ? ' portrait' : ' portraits') + ' left' : n + (n === 1 ? ' free portrait' : ' free portraits') + ' left'));
    var tail = function (node) { var t = el('span', 'lab-credits-act'); t.appendChild(document.createTextNode(' · ')); t.appendChild(node); line.appendChild(t); };
    if (account.signedIn) {
      line.appendChild(el('span', 'lab-credits-who', ' · ' + account.email));
      // Sign out for both ways in (Giacomo, 06/10: an email sign-in had no way out): the lab's own session is
      // forgotten on this device, and a Shopify customer is also signed out of Shopify.
      var out = el('button', 'lab-link', 'Sign out'); out.type = 'button';
      out.addEventListener('click', function () {
        stored('hq-session', null);
        if (window.HQ_CUSTOMER && window.HQ_ACCOUNT) location.href = window.HQ_ACCOUNT.logout; else location.reload();
      });
      tail(out);
      if (!historyLoaded) { historyLoaded = true; loadServerHistory(); }
    }
    else { var link = el('button', 'lab-link', 'Sign in'); link.type = 'button'; link.addEventListener('click', function () { registerModal(); }); tail(link); }
  }
  // ---------- delivery countries ----------
  // The FAQ lists the shop's markets (window.HQ_SHOP.ships) that take prints: since the digital file alone is sold in
  // more countries, the markets also hold countries we don't print for, filtered out with window.HQ_DELIVERY.ship.
  var WITH_THE = { GB: 1, US: 1, NL: 1, PH: 1, AE: 1, CZ: 1, DO: 1, BS: 1, GM: 1, CF: 1, KY: 1, VA: 1 };
  function shipNames() { var D = window.HQ_DELIVERY; return ((window.HQ_SHOP && window.HQ_SHOP.ships) || []).filter(function (c) { return !D || D.ship[c.c]; }).map(function (c) { return (WITH_THE[c.c] ? 'the ' : '') + c.n; }); }
  function listText(n) { return n.length > 1 ? n.slice(0, -1).join(', ') + ' and ' + n[n.length - 1] : n.join(''); }
  (function () { var n = shipNames(); if (n.length) document.querySelectorAll('.ship-list').forEach(function (s) { s.textContent = listText(n); }); })();

  function refreshMe() {
    return api('/api/me').then(function (m) {
      showMe(m);
      // Where the visitor connects from (Cloudflare): the product picker preselects it as "Deliver to".
      if (m && m.country && !window.HQ_VISITOR) { window.HQ_VISITOR = m.country; dispatchEvent(new CustomEvent('hq:country', { detail: m.country })); }
      // First visit after signing in with Shopify: the account was just made on the lab server.
      if (m && m.fresh) {
        modal('Welcome aboard, partner!', m.limited
          ? 'Your account is ready. Free portraits for new accounts have already been used on this device this week, so yours unlock with your first order.'
          : '6 portraits have been added to your account.', function (b, a, c) { a.appendChild(button('Got it', '', c)); });
      }
    }).catch(function () {});
  }
  setTimeout(refreshMe, 0);

  // Keyboard and screen readers (27/10/2026): the title names the dialog, the focus lands on the first control you can
  // use (the select of "What should we fix?", not its still-disabled button), Tab stays inside, Escape closes, and on
  // close the focus goes back where it was.
  var modalSeq = 0, modalStack = [];
  function modal(title, text, build) {
    var back = el('div', 'lab-modal-back'), box = el('div', 'lab-modal'), id = 'lab-modal-t' + (++modalSeq), before = document.activeElement;
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-labelledby', id);
    var h = el('h3', '', title); h.id = id; box.appendChild(h);
    if (text) box.appendChild(el('p', '', text));
    var actions = el('div', 'lab-actions');
    function controls() {
      return Array.prototype.filter.call(box.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])'), function (c) { return c.offsetParent !== null; });
    }
    function keys(e) {
      if (modalStack[modalStack.length - 1] !== back) return; // only the top pop-up answers
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
      if (e.key !== 'Tab') return;
      var c = controls(); if (!c.length) return;
      if (!box.contains(document.activeElement)) { e.preventDefault(); c[0].focus(); }
      else if (e.shiftKey && document.activeElement === c[0]) { e.preventDefault(); c[c.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === c[c.length - 1]) { e.preventDefault(); c[0].focus(); }
    }
    var close = function () {
      if (!back.parentNode) return;
      back.remove(); document.removeEventListener('keydown', keys, true);
      modalStack = modalStack.filter(function (m) { return m !== back; });
      if (before && before.focus && document.contains(before)) before.focus();
    };
    build(box, actions, close);
    box.appendChild(actions); back.appendChild(box); document.body.appendChild(back);
    modalStack.push(back);
    document.addEventListener('keydown', keys, true);
    var first = controls()[0]; if (first) first.focus();
    return close;
  }

  function outOfCredits() {
    if (account.blocked) return blockedModal();
    if (!account.signedIn) return registerModal(true);
    modal("You've used all your portraits", 'Complete your order and we will unlock 4 more portraits, so you can make the next gift straight away.', function (box, actions, close) {
      actions.appendChild(button('Go to cart', '', function () { close(); location.href = shopRoot() + 'cart'; }));
      actions.appendChild(button('Maybe later', 'btn-line', close));
    });
  }

  // "Photo tips" pop-up: 3 good examples and 4 to avoid (fictional people, generated for this page).
  var TIPS_GOOD = [['good-1', 'Straight on'], ['good-2', 'Looking at the camera'], ['good-3', 'Soft, even light']];
  var TIPS_BAD = [['bad-expression', 'Big expressions'], ['bad-profile', 'Side view'], ['bad-covered', 'Covered face'], ['bad-shadows', 'Harsh shadows']];
  function tipsModal() {
    modal('How to pick the best photo', 'One person, face to the camera, good light. A normal phone photo is perfect: no need for a professional shot.', function (box, actions, close) {
      box.classList.add('lab-modal-wide');
      function group(title, mark, cls, items) {
        box.appendChild(el('p', 'lab-tips-title ' + cls, mark + ' ' + title));
        var grid = el('div', 'lab-tips-grid');
        items.forEach(function (it) {
          var fig = el('figure', 'lab-tip ' + cls);
          var img = el('img'); img.src = HQ_A + 'lab-tip-' + it[0] + '.jpg'; img.alt = it[1]; img.width = 320; img.height = 320; img.loading = 'lazy';
          fig.appendChild(img); fig.appendChild(el('span', 'lab-tip-mark', mark)); fig.appendChild(el('figcaption', '', it[1]));
          grid.appendChild(fig);
        });
        box.appendChild(grid);
      }
      group('Great photos', '\u2705', 'good', TIPS_GOOD);
      group('Avoid', '\u274C', 'bad', TIPS_BAD);
      box.appendChild(el('p', 'lab-hint', 'Glasses are fine. Sunglasses, hats, filters and group photos make the likeness weaker.'));
      actions.appendChild(button('Got it', '', close));
    });
  }
  $('tips').addEventListener('click', tipsModal);

  function shopSignIn(ranOut) {
    modal(ranOut ? 'Want to keep going?' : 'Sign in or create an account',
      (ranOut ? "You've used your 4 free portraits. Sign in with your email and get 6 more portraits." : 'Sign in with your email to get 6 portraits and find your portraits on any device.') +
      ' We send you a code by email, no password needed.',
      function (box, actions, close) {
        actions.appendChild(button('Continue', '', function () {
          location.href = shopRoot() + 'customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search);
        }));
        actions.appendChild(button('Not now', 'btn-line', close));
      });
  }
  function registerModal(ranOut) {
    if (window.HQ_SHOP) return shopSignIn(ranOut);
    modal(ranOut ? 'Want to keep going?' : 'Sign in or create an account',
      ranOut ? "You've used your 4 free portraits. Create a free account and get 6 more portraits." : 'Create a free account and get 6 portraits, or sign in to pick up where you left off.',
      function (box, actions, close) {
        var label = el('label', 'lab-field'); label.appendChild(el('span', '', 'Email'));
        var email = el('input'); email.type = 'email'; email.autocomplete = 'email'; email.required = true; label.appendChild(email);
        var news = el('label', 'lab-consent'); var nb = el('input'); nb.type = 'checkbox';
        news.appendChild(nb); news.appendChild(el('span', '', 'Send me new portrait styles and occasional offers. (Optional)'));
        var err = el('p', 'lab-modal-err');
        box.appendChild(label); box.appendChild(news); box.appendChild(err);
        box.appendChild(el('p', 'lab-hint', 'Lab test: no code is sent. In the shop you will confirm your email with a code.'));
        var asTyped = false;
        function submit() {
          clear(err);
          api('/api/login', { email: email.value, newsletter: nb.checked, acceptAsTyped: asTyped }).then(function (r) {
            stored('hq-session', r.token); close();
            refreshMe().then(function () {
              var title = r.isNew ? 'Welcome aboard, partner!' : 'Welcome back!';
              var text = !r.isNew ? 'You have ' + r.credits + ' portraits left.'
                : r.limited ? "Your account is ready. Free portraits for new accounts have already been used on this device this week, so yours unlock with your first order."
                : '6 portraits have been added to your account.';
              modal(title, text, function (b, a, c) { a.appendChild(button('Got it', '', c)); });
            });
          }).catch(function (e) {
            err.appendChild(document.createTextNode(e.message + ' '));
            if (e.need === 'typo' && e.suggestion) {
              var fix = el('button', 'lab-link', 'Use ' + e.suggestion); fix.type = 'button';
              fix.addEventListener('click', function () { email.value = e.suggestion; asTyped = false; submit(); });
              var keep = el('button', 'lab-link', 'Keep what I typed'); keep.type = 'button';
              keep.addEventListener('click', function () { asTyped = true; submit(); });
              err.appendChild(fix); err.appendChild(document.createTextNode(' · ')); err.appendChild(keep);
            }
          });
        }
        actions.appendChild(button(ranOut ? 'Create account & get 6 portraits' : 'Continue', '', submit));
        actions.appendChild(button('Maybe later', 'btn-line', close));
      });
  }

  function strikeModal(level) {
    if (level === 'blocked') return blockedModal();
    modal('This photo can\'t be accepted', "Please don't upload sensitive content. Another attempt like this will block your access.", function (b, a, c) { a.appendChild(button('I understand', '', c)); });
  }
  function blockedModal() {
    account.blocked = true; showMe();
    modal('Access blocked', "We can't accept photos from you anymore.", function (b, a, c) { a.appendChild(button('Close', 'btn-line', c)); });
  }

  // Credit gate in front of every paid step.
  function startGen() { if (!hasCredit()) return noCredits(); generate(); }

  // The permission is the line above the photo box (Giacomo, 11/10/2026: no tick box, adding a photo confirms it); its
  // wording goes with every check, so the history keeps what the visitor read.
  var CONSENT_TEXT = document.querySelector('.up-permission').textContent;

  // Two ways in, same flow: the photo box (gallery, files) and, on phones, the selfie button (front camera).
  ['photo', 'selfie'].forEach(function (id) {
    var input = $(id); if (!input) return;
    input.addEventListener('click', function (e) {
      if (!hasCredit()) { e.preventDefault(); outOfCredits(); }
    });
    input.addEventListener('change', function () {
      var file = this.files && this.files[0];
      if (!file) return;
      track('photo_upload', { source: id === 'selfie' ? 'camera' : 'file' });
      loadPhoto(file).then(function (p) {
        showPhoto(p.canvas.toDataURL('image/jpeg', 0.9));
        runCheck(p);
      }).catch(function () {
        // Never silent again: say so, and log what the phone handed over (type and size only, never the photo).
        track('photo_unreadable', { type: file.type || 'unknown', mb: Math.round(file.size / 1e5) / 10 });
        checkSeq++; $('picked').hidden = true;
        var box = clear($('check')); box.hidden = false; box.className = 'lab-message bad';
        box.appendChild(el('p', 'lead', "We couldn't open this photo. Some phones save photos in a format browsers can't read: try another one, or take a screenshot of it and upload that."));
        var actions = el('div', 'lab-actions'); actions.appendChild(button('Upload another photo', '', pickAgain)); box.appendChild(actions);
      });
      this.value = ''; // the same selfie again still fires change
    });
  });

  // The photo box and the selfie button are labels made focusable in index.html (27/10/2026, keyboard and screen
  // readers could not reach them): Enter or Space opens the file picker, like a click.
  document.querySelectorAll('label[for="photo"], label[for="selfie"]').forEach(function (l) {
    l.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault(); var input = $(l.htmlFor); if (input) input.click();
    });
  });

  // Checks a prepared photo: the uploaded one, or (behind the scenes) the crop around the tapped face.
  var checkSeq = 0;
  function runCheck(p) {
    var seq = ++checkSeq;
    state ={ id: null, roll: 0, eyes: null, canvas: p.canvas, originalWidth: p.originalWidth, accepted: [], tries: [], chosen: !!p.chosen };
    genFrom = 'drawer';
    var box = clear($('check')); box.hidden = false; box.className = 'lab-message';
    box.appendChild(el('p', 'lab-wait', p.chosen ? 'Checking the face you picked...' : 'Checking your photo...'));
    var photo = p.canvas.toDataURL('image/jpeg', 0.9);
    api('/api/check', { template: TEMPLATE, photo: photo, originalWidth: p.originalWidth, originalHeight: p.originalHeight, chosen: !!p.chosen, consent: true, consentText: CONSENT_TEXT }).then(function (res) {
      if (seq !== checkSeq) return; // the photo was removed or replaced meanwhile
      state.id = res.id; state.roll = res.roll || 0; state.eyes = res.eyes || null;
      track('photo_check', { verdict: res.verdict, code: res.code || '' });
      showCheck(res);
      if (res.strike) strikeModal(res.strike);
    }).catch(function (e) {
      if (e.need === 'blocked') blockedModal();
      if (seq !== checkSeq) return;
      box.className = 'lab-message bad'; clear(box);
      box.appendChild(el('p', 'lead', e.message || "We couldn't read this photo. Please try another one."));
      var actions = el('div', 'lab-actions'); actions.appendChild(button('Upload another photo', '', pickAgain)); box.appendChild(actions);
    });
  }

  // ---------- generation ----------
  // "Create my portrait" collapses the pop-up to the loading bar (index.html: HqView.loading). A good result opens
  // the result page; an error goes back to where the customer came from with the message.

  var TEMPLATE_NAMES = { 'cowboy-trex': 'Rider on a T-Rex', longhorn: 'Rider on a Longhorn', 'cowboy-portrait': 'Wild West Cowboy', aviator: 'WWII Fighter Pilot', 'wwii-general': 'WWII Officer', soldier: 'WWII Soldier', golf: '1920s Golfer', sailor: 'Old Sailor', gangster: 'Prohibition Gangster', 'trophy-fish': 'Trophy Fisherman', 'civil-war': 'Civil War General', bigfoot: 'Bigfoot Explorer', 'bigfoot-victorian': 'Victorian Bigfoot', headless: 'The Headless Gentleman', highland: 'Highland Gentleman' };
  var genFrom = 'drawer';

  function showProgress() {
    var lines = WAIT_LINES[TEMPLATE] || WAIT_LINES['cowboy-trex'];
    var fill = $('gen-fill'), line = $('gen-line'), bar = fill.parentNode, pcts = bar.querySelectorAll('.gen-pct');
    // The percentage sits in the middle of the bar, dark over the gold part and light over the rest.
    function at(p) { fill.style.width = p + '%'; bar.style.setProperty('--p', p + '%'); pcts.forEach(function (n) { n.textContent = Math.round(p) + '%'; }); }
    at(0); line.textContent = lines[0];
    window.HqView.loading(true);
    var started = Date.now(), i = 0;
    var timer = setInterval(function () {
      var t = (Date.now() - started) / 1000;
      at(Math.min(92, (t / EXPECTED_SECONDS) * 92)); // never "done" before it is
      var next = Math.min(lines.length - 1, Math.floor(t / (EXPECTED_SECONDS / lines.length)));
      if (next !== i) { i = next; line.textContent = lines[i]; }
    }, 250);
    return function done() { clearInterval(timer); at(100); };
  }

  // The photo stays loaded after a portrait, so its buttons unlock again whatever the outcome: back on the home,
  // another costume can use the same photo without uploading it again (Giacomo, 01/10/2026).
  function lockCheck(on) { $('check').querySelectorAll('button').forEach(function (b) { b.disabled = on; }); }
  function generate() {
    track('generate_start', { attempt: (state.tries || []).length + 1 });
    lockCheck(true);
    var finish = showProgress();
    var body = { id: state.id, accepted: state.accepted, template: TEMPLATE };
    if (state.eyes) body.prepared = prepared(state.canvas, state.eyes, state.roll);
    if (retryFix) { body.retry = retryFix; retryFix = null; }
    api('/api/generate', body).then(function (g) {
      if (g.me) showMe(g.me);
      rememberPending({ id: state.id, task: g.task, template: TEMPLATE, at: new Date().toISOString() });
      poll(g.task, finish, 0);
    }).catch(function (e) {
      finish(); window.HqView.loading(false); lockCheck(false);
      if (e.need) { refreshMe(); return e.need === 'blocked' ? blockedModal() : noCredits(); }
      showError(e.message);
    });
  }

  function poll(task, finish, n) {
    setTimeout(function () {
      api('/api/status?id=' + encodeURIComponent(state.id) + '&task=' + encodeURIComponent(task)).then(function (s) {
        if (s.status === 'processing') return poll(task, finish, n + 1);
        forgetPending(task);
        finish(); window.HqView.loading(false); lockCheck(false);
        if (s.status === 'failed') { track('generate_failed'); refreshMe(); return showError(s.message, true); }
        var v = { id: state.id, task: task, template: TEMPLATE, at: new Date().toISOString(), preview: s.preview };
        track('preview_ready', { attempt: state.tries.length + 1 });
        state.tries.push(v);
        addVersion(v);
        showResult(v);
      }).catch(function (e) {
        if (n < 60) return poll(task, finish, n + 1); // a network blip: keep waiting, the task is already paid
        finish(); window.HqView.loading(false); lockCheck(false); showError(e.message);
      });
    }, n === 0 ? 20000 : 5000);
  }

  // Errors land where the customer was: the pop-up (with the photo) or the result page (after "Retry").
  function showError(message, canRetry) {
    if (genFrom === 'result') return resultMessage(message, canRetry ? [['Try again', '', retry]] : [['Upload another photo', '', newPhoto]]);
    window.HqView.openDrawer();
    var box = clear($('check')); box.hidden = false; box.className = 'lab-message bad';
    box.appendChild(el('p', 'lead', message));
    var actions = el('div', 'lab-actions');
    if (canRetry) actions.appendChild(button('Try again', '', startGen));
    actions.appendChild(button('Upload another photo', canRetry ? 'btn-line' : '', pickAgain));
    box.appendChild(actions);
  }

  // ---------- "Your versions": this device, and the account when signed in ----------
  var VERSIONS_KEY = 'hq-versions', versions = [], previews = {};
  try { versions = JSON.parse(stored(VERSIONS_KEY) || '[]'); } catch (e) { versions = []; }
  function saveVersions() { try { localStorage.setItem(VERSIONS_KEY, JSON.stringify(versions.filter(function (v) { return !v.demo; }).slice(0, 12))); } catch (e) { versions.forEach(function (v, i) { if (i > 5) v.thumb = null; }); } }
  function thumbOf(src) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () { var c = document.createElement('canvas'); c.width = 240; c.height = Math.round(240 * img.height / img.width); c.getContext('2d').drawImage(img, 0, 0, c.width, c.height); resolve(c.toDataURL('image/jpeg', 0.7)); };
      img.onerror = function () { resolve(null); };
      img.src = src;
    });
  }
  function addVersion(v) {
    previews[v.task] = v.preview;
    versions = versions.filter(function (o) { return o.task !== v.task; });
    var entry = { id: v.id, task: v.task, template: v.template, at: v.at, thumb: null };
    versions.unshift(entry);
    thumbOf(v.preview).then(function (t) { entry.thumb = t; saveVersions(); renderVersions(); });
    saveVersions();
  }
  function previewOf(v) {
    if (previews[v.task]) return Promise.resolve(previews[v.task]);
    return api('/api/status?id=' + encodeURIComponent(v.id) + '&task=' + encodeURIComponent(v.task)).then(function (s) {
      if (s.status !== 'done') throw new Error('gone');
      previews[v.task] = s.preview;
      if (!v.thumb) thumbOf(s.preview).then(function (t) { v.thumb = t; saveVersions(); renderVersions(); });
      return s.preview;
    });
  }
  // Signed in: merge the account's portraits, then fetch the missing thumbnails a few at a time.
  function loadServerHistory() {
    if (!account.signedIn) return;
    api('/api/history').then(function (h) {
      (h.versions || []).forEach(function (s) {
        if (!versions.some(function (o) { return o.task === s.task; })) versions.push({ id: s.id, task: s.task, template: s.template, at: s.at, thumb: null });
      });
      versions.sort(function (a, b) { return a.at < b.at ? 1 : -1; });
      versions = versions.slice(0, 12); saveVersions(); renderVersions();
      versions.filter(function (v) { return !v.thumb; }).slice(0, 8).reduce(function (p, v) {
        return p.then(function () { return previewOf(v).catch(function () { versions = versions.filter(function (o) { return o !== v; }); saveVersions(); }); });
      }, Promise.resolve()).then(renderVersions);
    }).catch(function () {});
  }
  window.HqView.hasVersions = function () { return versions.length > 0; };

  // A portrait still being made is remembered on this device (its own list, "Your versions" never shows it empty).
  // If the page closes during the wait (17/10/2026: a visitor left during the T-Rex and never saw it), the server
  // finishes it anyway; on the next visit it opens straight away and joins "Your versions". Dropped after a day.
  var PENDING_KEY = 'hq-pending', pending = [];
  try { pending = JSON.parse(stored(PENDING_KEY) || '[]'); } catch (e) { pending = []; }
  function savePending() { try { localStorage.setItem(PENDING_KEY, JSON.stringify(pending.slice(0, 6))); } catch (e) {} }
  function rememberPending(v) { pending = [v].concat(pending.filter(function (o) { return o.task !== v.task; })); savePending(); }
  function forgetPending(task) { pending = pending.filter(function (o) { return o.task !== task; }); savePending(); }
  function resumePending() {
    var shown = false;
    pending.slice().forEach(function (v) {
      if (!(Date.now() - Date.parse(v.at) < 24 * 3600 * 1000)) return forgetPending(v.task);
      api('/api/status?id=' + encodeURIComponent(v.id) + '&task=' + encodeURIComponent(v.task)).then(function (s) {
        if (s.status === 'processing') return;
        forgetPending(v.task);
        if (s.status !== 'done' || versions.some(function (o) { return o.task === v.task; })) return;
        var r = { id: v.id, task: v.task, template: v.template, at: v.at, preview: s.preview };
        addVersion(r); renderVersions();
        track('preview_recovered');
        var view = document.body.dataset.view || 'home'; // unset until the first change of view
        if (!shown && view === 'home' && !document.body.classList.contains('drawn')) { shown = true; showResult(r); }
      }).catch(function () {});
    });
  }

  var current = null;
  function openVersion(v) {
    previewOf(v).then(function (p) { showResult({ id: v.id, task: v.task, template: v.template, at: v.at, preview: p }); })
      .catch(function () { resultMessage('That portrait has expired (we keep them for 30 days).'); });
  }
  function verButton(v, before) {
    var b = el('button', 'ver'); b.type = 'button'; b.setAttribute('aria-label', (TEMPLATE_NAMES[v.template] || 'Portrait') + ', ' + new Date(v.at).toLocaleDateString());
    if (current && current.task === v.task) b.setAttribute('aria-current', 'true');
    if (v.thumb) { var im = el('img'); im.src = v.thumb; im.alt = ''; b.appendChild(im); } else b.classList.add('ver-empty');
    b.addEventListener('click', function () { if (before) before(); openVersion(v); });
    return b;
  }
  // One line, never a scrollbar: as many as fit, and the last slot becomes "+N" that opens them all.
  function renderVersions() {
    var row = $('versions'); if (!row) return;
    clear(row);
    $('ver-box').hidden = versions.length < 2;
    $('ver-all').textContent = 'See all (' + versions.length + ')';
    var fit = Math.max(3, Math.floor((row.clientWidth + 10) / 74)), shown = versions;
    if (versions.length > fit) {
      shown = versions.slice(0, fit - 1);
      var cur = current && versions.filter(function (v) { return v.task === current.task; })[0];
      if (cur && shown.indexOf(cur) < 0) shown[shown.length - 1] = cur; // the one on screen stays in the strip
    }
    shown.forEach(function (v) { row.appendChild(verButton(v)); });
    if (shown.length < versions.length) {
      var more = el('button', 'ver ver-more', '+' + (versions.length - shown.length)); more.type = 'button'; more.addEventListener('click', allVersions);
      more.setAttribute('aria-label', 'See all ' + versions.length + ' portraits');
      row.appendChild(more);
    }
  }
  var fitWas = 0;
  addEventListener('resize', function () {
    var row = $('versions'), fit = row ? Math.floor((row.clientWidth + 10) / 74) : 0;
    if (fit && fit !== fitWas) { fitWas = fit; renderVersions(); }
  });
  // "See all": every version in a pop-up, the one on screen ticked.
  function allVersions() {
    var back;
    function esc(e) { if (e.key === 'Escape') shut(); }
    function shut() { back.remove(); document.removeEventListener('keydown', esc); }
    modal('All your versions', versions.length + ' portraits. Tap one to see it again or order it.', function (box, actions) {
      box.classList.add('lab-modal-wide', 'ver-modal');
      var grid = el('div', 'ver-grid');
      versions.forEach(function (v) { grid.appendChild(verButton(v, function () { shut(); })); });
      box.appendChild(grid);
      var x = box.insertBefore(el('button', 'ver-x', '×'), box.firstChild); x.type = 'button'; x.setAttribute('aria-label', 'Close');
      x.addEventListener('click', function () { shut(); });
    });
    back = document.body.lastElementChild;
    document.addEventListener('keydown', esc);
    back.addEventListener('click', function (e) { if (e.target === back) shut(); });
  }
  $('ver-all').addEventListener('click', allVersions);

  // ---------- the result page ----------
  function showResult(v) {
    current = v; genFrom = 'result';
    window.HqView.closeDrawer(true);
    window.HqView.show('result');
    $('res-img').src = v.preview; $('res-img').alt = 'Your portrait: ' + (TEMPLATE_NAMES[v.template] || 'portrait');
    $('res-cap').textContent = TEMPLATE_NAMES[v.template] || '';
    $('res-msg').hidden = true;
    // Option B (Giacomo, 12/10/2026): the question the visitor is really asking, a "yes" that says what comes next, and
    // a "not quite" that makes another try feel normal and free (the first US visitor from the ads left after one try).
    var actions = clear($('res-actions'));
    // Option A (Giacomo, 17/10/2026): three visitors out of three stopped here. "Does it look like him?" assumed a gift
    // giver, and "Choose the print" promised a print to countries that only get the digital file. The next page shows
    // what can be delivered where, and the visitor's country is not always the gift's.
    actions.appendChild(el('p', 'res-q', 'Happy with it?'));
    // "Print or download" (Giacomo, 18/10/2026): says what you get, not what you look at, and tells the visitor who
    // would only screenshot it that a clean full-size file exists. The next page still leads with the prints.
    var yes = button('Yes! Print or download', '', function () { track('result_yes'); pick(current); });
    if (window.Hq && Hq.ICON && Hq.ICON.arrow) yes.insertAdjacentHTML('beforeend', Hq.ICON.arrow);
    actions.appendChild(yes);
    actions.appendChild(button('Not quite: try again', 'btn-line', askRetry));
    var left = account.credits > 0 && !account.blocked && !v.demo ? account.credits : 0;
    actions.appendChild(el('p', 'res-note', left ? 'Free: ' + left + (left === 1 ? ' try' : ' tries') + ' left. Each one is a new take.' : 'Each try is a new take of the same photo.'));
    renderVersions();
    window.scrollTo(0, 0);
  }
  $('res-img').addEventListener('click', function () { if (current) zoom(current.preview); });
  $('res-new').addEventListener('click', newPhoto);
  $('res-why').addEventListener('click', askWhy);
  window.HqView.showLatest = function () {
    var v = versions[0]; if (!v) return;
    previewOf(v).then(function (p) { showResult({ id: v.id, task: v.task, template: v.template, at: v.at, preview: p }); }).catch(function () {});
  };

  function resultMessage(text, buttons) {
    var box = clear($('res-msg')); box.hidden = false; box.className = 'lab-message';
    box.appendChild(el('p', 'lead', text));
    if (buttons && buttons.length) {
      var a = el('div', 'lab-actions');
      buttons.forEach(function (b) { a.appendChild(button(b[0], b[1], b[2])); });
      box.appendChild(a);
    }
  }

  // ---------- sample portraits: walk through every step without paying for a generation ----------
  // Lab tools "Load sample portraits" or /lab/#demo. The samples are the four costume pictures; nothing reaches
  // Runware or the history, and "Add to cart" records nothing.
  var DEMO = [['cowboy-trex', 'cowboy'], ['longhorn', 'longhorn'], ['cowboy-portrait', 'cowboy-portrait'], ['aviator', 'aviator'], ['wwii-general', 'wwii-general'], ['soldier', 'soldier'], ['golf', 'golf'], ['sailor', 'sailor'], ['gangster', 'gangster'], ['trophy-fish', 'trophy-fish'], ['civil-war', 'civil-war'], ['bigfoot', 'bigfoot'], ['bigfoot-victorian', 'bigfoot-victorian'], ['headless', 'headless'], ['highland', 'highland']], demoAt = 0;
  function demoVersion() {
    var d = DEMO[demoAt++ % DEMO.length];
    return { id: 'demo', task: 'demo-' + demoAt + '-' + Date.now(), template: d[0], at: new Date().toISOString(), preview: HQ_A + 'lab-img-' + d[1] + '.jpg?v=45', demo: true };
  }
  function addDemo(v) {
    previews[v.task] = v.preview;
    var entry = { id: v.id, task: v.task, template: v.template, at: v.at, thumb: null, demo: true };
    versions.unshift(entry);
    thumbOf(v.preview).then(function (t) { entry.thumb = t; renderVersions(); });
  }
  function demoRetry() {
    var next = DEMO[demoAt % DEMO.length][0], b = document.querySelector('.lab-pick-style[data-template="' + next + '"]');
    if (b) b.click(); // the loading lines follow the next sample's costume
    genFrom = 'result';
    var finish = showProgress();
    setTimeout(function () { finish(); setTimeout(function () { window.HqView.loading(false); var v = demoVersion(); addDemo(v); showResult(v); }, 400); }, 3500);
  }
  window.HqView.demo = function () { var v = demoVersion(); addDemo(v); showResult(v); };

  // "Not quite: try again" (Giacomo, 27/10/2026): the visitor must say what was wrong, and the server fixes exactly that
  // on the next try (RETRY_FIXES in tools/face-lab/rules.mjs) instead of rolling the dice again. No reason, no new try.
  // The note is always optional and only Giacomo reads it: it never reaches the generator.
  var RETRY_REASONS = [['head_small', 'The head looks too small'], ['head_big', 'The head looks too big'], ['likeness', "The face doesn't look like him"],
    ['skin', 'The skin tone is wrong'], ['hair', 'The hair or beard is wrong'], ['age', 'He looks older or younger than he is'],
    ['glasses', 'The glasses are missing or wrong'], ['expression', 'The expression looks odd'], ['hands', 'The hands look wrong'], ['other', 'Something else']];
  var retryFix = null;
  function askRetry() {
    modal('What should we fix?', 'Pick what is not right and the next try will fix exactly that.', function (box, actions, close) {
      var sel = el('select', 'lab-why-select'); sel.setAttribute('aria-label', 'What should we fix?');
      var none = el('option', '', 'Choose what to fix'); none.value = ''; sel.appendChild(none);
      RETRY_REASONS.forEach(function (r) { var o = el('option', '', r[1]); o.value = r[0]; sel.appendChild(o); });
      var text = el('textarea', 'lab-why'); text.rows = 3; text.maxLength = 300; text.hidden = true;
      text.setAttribute('aria-label', 'Add a detail');
      box.appendChild(sel); box.appendChild(text);
      var go = button('Try again', '', function () {
        track('result_retry', { reason: sel.value });
        close();
        retry({ reason: sel.value, note: text.value.trim() });
      });
      function update() {
        text.hidden = !sel.value;
        text.placeholder = sel.value === 'other' ? 'Tell us in a few words (optional)' : 'Add a detail (optional), e.g. "his beard is shorter"';
        go.disabled = !sel.value;
      }
      go.disabled = true;
      sel.addEventListener('change', function () { update(); if (!text.hidden) text.focus(); });
      text.addEventListener('input', update);
      actions.appendChild(go);
      actions.appendChild(button('Cancel', 'btn-line', close));
    });
  }

  // "Retry": another take with the same photo and costume, with the fix the visitor asked for (askRetry). After a
  // failed generation it is called with no fix. No photo in this visit (page reloaded, or a version from another
  // day): start again from the pop-up.
  function retry(fix) {
    if (current && current.demo) return demoRetry();
    if (!hasCredit()) return noCredits();
    // A portrait reopened from "Your versions" may belong to an earlier photo or visit (27/10/2026: the retry used the
    // last photo checked, so the credit went on the wrong face). Since the server makes the face crop itself from the
    // photo it keeps for 30 days, the portrait's own session id is all a retry needs; an expired photo gets the
    // server's "upload it again" message, before any credit is taken.
    if (current && current.id && current.id !== state.id) state = { id: current.id, roll: 0, eyes: null, canvas: null, accepted: [], tries: [], chosen: false };
    if (!state.id) return newPhoto();
    retryFix = fix && fix.reason ? fix : null; // a button click passes its event: only a real fix counts
    genFrom = 'result';
    window.HqView.openDrawer(); // opening syncs the costume on stage, so set the portrait's own costume after it
    if (current && current.template) {
      var b = document.querySelector('.lab-pick-style[data-template="' + current.template + '"]'); if (b) b.click();
    }
    generate();
  }

  // Out of previews: a message, not a dead end. Guests can sign in for more or wait for the refill date.
  function noCredits() {
    if (account.blocked) return blockedModal();
    var when = account.refillAt ? new Date(account.refillAt).toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' }) : null;
    var text = account.signedIn
      ? "You've used all your portraits for now. Add one to your cart or complete an order and we'll unlock 4 more."
      : "You've used your free previews. Sign in with your email for 6 more" + (when ? ', or come back on ' + when + ' for another free one.' : '.');
    if (genFrom === 'result' || !window.HqView.drawerOpen()) {
      return resultMessage(text, account.signedIn ? [] : [['Sign in for 6 more', '', function () { registerModal(true); }]]);
    }
    outOfCredits();
  }

  function newPhoto() {
    genFrom = 'drawer';
    clear($('check')).hidden = true; clear($('picked')).hidden = true;
    $('photo').value = '';
    window.HqView.create();
  }

  // ---------- step 2: format, frame and size ----------
  function pick(t) {
    track('format_view');
    window.HqView.show('shop');
    var slot = clear($('shop-slot')), actions = clear($('shop-actions'));
    // The choice rides inside the button: "Add to cart · $169" over "Black framed canvas, 16 × 20 in".
    var buy = button('', 'pp-cart', function () {
      if (!consent.hidden && !tick.checked) { nudge(consent); tick.focus(); return; }
      confirm(t, picker.state());
    });
    var main = buy.appendChild(el('span', 'pp-cart-main')), sub = buy.appendChild(el('small', 'pp-cart-sub'));
    // Right under the button (Giacomo, 05/10: too much between the choice and the cart before); prints only.
    var note = el('p', 'pp-note');
    note.appendChild(el('span', 'pp-note-i')).setAttribute('aria-hidden', 'true');
    note.appendChild(el('span', '', 'A person checks every print by hand before it is printed and shipped.'));
    // EU/EEA digital file alone: the right to cancel ends with the customer's express consent (Directive 2011/83 art.
    // 16(m)), asked before the purchase button and kept as a cart attribute (docs/withdrawal-digital-consent.md).
    // Under the "digital file only" switch; until it is ticked the cart button looks off and a tap shakes the box.
    var consent = el('label', 'pp-consent'), tick = consent.appendChild(el('input'));
    tick.type = 'checkbox';
    consent.appendChild(el('span', '', 'I want my file now and understand I lose my 14-day right to cancel once it is ready.'));
    function lock() { var l = !consent.hidden && !tick.checked; buy.classList.toggle('is-locked', l); buy.setAttribute('aria-disabled', String(l)); }
    tick.addEventListener('change', lock);
    var picker = HqProducts.mount({ portrait: t.preview, costume: t.template, onChange: function (p) {
      var off = window.HQ_SHOP && !p.variant;
      main.textContent = p.loading ? 'Updating prices…' : off ? 'Not available right now' : 'Add to cart · ' + (p.priceText || '$' + p.price);
      sub.textContent = p.label;
      buy.disabled = !!off;
      consent.hidden = !needsConsent(p);
      lock();
      note.hidden = p.digitalOnly;
    } });
    slot.appendChild(picker.node);
    picker.node.querySelector('.pp-pick').appendChild(consent);
    actions.appendChild(buy);
    actions.appendChild(note);
    actions.appendChild(button('Back to your portrait', 'btn-line', function () { history.back(); }));
    window.scrollTo(0, 0);
  }

  // ---------- step 3: the order ----------
  // On the Shopify shop (window.HQ_SHOP) the pick goes into the real cart, with the portrait attached as line item
  // properties; on the old Namecheap lab it stops at the order view. /api/choose records the approved preview and
  // its time either way (the chargeback evidence).
  function shopRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  // The account and cart icons in the header (Giacomo, 6 Oct 2026), as on the other pages: shown on the shop only, with the number of items once there are any.
  function cartCount() {
    if (!window.HQ_SHOP || !$('cart-link')) return;
    $('cart-link').href = shopRoot() + 'cart'; $('cart-link').hidden = false;
    if (window.HQ_ACCOUNT && $('acct-link')) { $('acct-link').href = window.HQ_ACCOUNT.account; $('acct-link').hidden = false; }
    fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
      var n = j.item_count || 0, badge = $('cart-count');
      badge.textContent = n; badge.hidden = !n;
      $('cart-link').setAttribute('aria-label', n ? 'Your cart, ' + n + (n === 1 ? ' item' : ' items') : 'Your cart');
    }).catch(function () {});
  }
  cartCount();
  addEventListener('pageshow', function (e) { if (e.persisted) cartCount(); });
  var EEA = 'AT BE BG CY CZ DE DK EE ES FI FR GR HR HU IE IT LT LU LV MT NL PL PT RO SE SI SK IS LI NO'.split(' ');
  // The EU withdrawal rules follow where the buyer lives, not the "Deliver to" country (27/10/2026: someone in Italy
  // buying the file for a relative in the US kept 14 days to cancel). So the box also shows when the visitor connects
  // from the EEA (window.HQ_VISITOR, the country Cloudflare sees). Visitors outside the EEA see nothing new.
  function needsConsent(p) { return !!(p.digitalOnly && (EEA.indexOf(p.country) !== -1 || EEA.indexOf(window.HQ_VISITOR) !== -1)); }
  function addToCart(t, product, thumb) {
    var props = { 'Portrait': TEMPLATE_NAMES[t.template] || 'Custom portrait' };
    if (!product.digitalOnly) props['Digital file'] = 'Included, free';
    props._lab_id = t.id || state.id; props._lab_task = t.task; props._approved_at = new Date().toISOString();
    // The cart shows this portrait (the watermarked preview, a signed lab-server link) instead of the product photo.
    if (thumb) props._thumb = thumb;
    return fetch(shopRoot() + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: product.variant, quantity: 1, properties: props }] })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'We could not add it to your cart. Please try again.');
        cartCount();
        var attrs = {}, oppref = opprefCookie();
        if (oppref) attrs._oppref = oppref;
        // Marketing cookies accepted in Shopify's banner: only then may the lab server send OpenAI the purchase with
        // the hashed email (privacy policy section 7, 10/10/2026). Written either way, so a later "no" clears it.
        var cp = window.Shopify && Shopify.customerPrivacy;
        attrs._mkt = cp && cp.marketingAllowed && cp.marketingAllowed() ? '1' : '';
        // The consent rides on the order (the email confirms it): when it was given and for which country.
        if (needsConsent(product)) attrs._digital_consent = new Date().toISOString() + ' ' + product.country + (window.HQ_VISITOR && window.HQ_VISITOR !== product.country ? ' (from ' + window.HQ_VISITOR + ')' : '');
        if (!Object.keys(attrs).length) return j;
        // A ticked consent must reach the order: one quiet second try if the first write fails. Never blocks the
        // cart; an EEA order that still arrives without it is flagged to Giacomo by the lab server (orders.js).
        var write = function () {
          return fetch(shopRoot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
            .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); });
        };
        return write().catch(function () { return write(); }).catch(function () {}).then(function () { return j; });
      });
    });
  }
  function orderView(t, product, note) {
    window.HqView.show('order');
    $('order-line').textContent = product.label + ', ' + (product.priceText || '$' + product.price) + '.' + (note || '');
    $('order-img').src = t.preview;
    if (!window.HQ_SHOP) return;
    var box = $('order-t').parentNode, hint = box.querySelector('.lab-hint');
    if (hint) hint.hidden = true;
    if ($('order-checkout')) return;
    var go = button('Go to checkout', '', function () {
      track('checkout_start', { value: product.price || 0, currency: (window.HQ_SHOP && window.HQ_SHOP.currency) || '' });
      setTimeout(function () { location.href = shopRoot() + 'checkout'; }, 150); // a moment for the pixel to send
    }); go.id = 'order-checkout';
    var cart = button('View your cart', 'btn-line', function () { location.href = shopRoot() + 'cart'; });
    var row = box.querySelector('.order-actions') || box, again = row.querySelector('.btn');
    if (again) again.classList.add('btn-line');
    row.insertBefore(go, again); row.insertBefore(cart, again);
  }
  function confirm(t, product) {
    if (t.demo) return orderView(t, product, ' (Sample portrait: nothing was recorded.)');
    var shop = !!window.HQ_SHOP;
    if (shop && !product.variant) return modal('Not available right now', 'This one is not available at the moment. Please pick another size or frame.', function (b, a, c) { a.appendChild(button('OK', '', c)); });
    if (confirm.busy) return; // a double tap would add the print twice
    confirm.busy = true;
    var chosen = api('/api/choose', { id: t.id || state.id, task: t.task, product: product });
    (shop ? chosen.catch(function () { return {}; }).then(function (r) { return addToCart(t, product, r && r.thumb).then(function () { return r; }); }) : chosen).then(function (r) {
      if (r.me) showMe(r.me);
      track('add_to_cart', { format: product.digitalOnly ? 'digital' : (product.mat || '') + '-' + (product.frame || '') + '-' + (product.size || ''), value: product.price || 0, currency: (window.HQ_SHOP && window.HQ_SHOP.currency) || '' });
      orderView(t, product);
      if (!r.signedIn) {
        modal('Added to your cart!', 'Making more than one gift? Create a free account and get 6 more portraits.', function (b, a, c) {
          a.appendChild(button('Create account', '', function () { c(); registerModal(); }));
          a.appendChild(button('Not now', 'btn-line', c));
        });
      } else if (r.credited) {
        modal('Added to your cart!', 'We added ' + r.credited + ' more portraits to your account, so you can make the next gift right away.', function (b, a, c) { a.appendChild(button('Great', '', c)); });
      } else {
        modal('Added to your cart!', 'Complete your order to unlock 4 more portraits for your next gift.', function (b, a, c) { a.appendChild(button('Got it', '', c)); });
      }
    }).catch(function (e) { modal('Something went wrong', e.message, function (b, a, c) { a.appendChild(button('Close', '', c)); }); })
      .then(function () { confirm.busy = false; });
  }

  // "None of these look right?": the note goes to Giacomo with the photo and the tries (review/ copies).
  function askWhy() {
    var id = (current && current.id) || state.id;
    modal("What's not right?", 'Pick the closest one. It goes straight to Giacomo, together with your photo and the portraits.', function (box, actions, close) {
      var sel = el('select', 'lab-why-select'); sel.setAttribute('aria-label', "What's not right?");
      ['Choose what went wrong', "The face doesn't look like him", 'The head looks too small', 'The head looks too big',
       'The skin tone is wrong', 'The hair or beard is wrong', 'He looks older or younger than he is',
       'The glasses are missing or wrong', 'The expression looks odd', 'The hands look wrong',
       "I can't see the portrait", 'Something else'].forEach(function (t, i) { var o = el('option', '', t); o.value = i ? t : ''; sel.appendChild(o); });
      var text = el('textarea', 'lab-why'); text.rows = 3; text.maxLength = 1000; text.hidden = true;
      text.placeholder = 'Tell us in a few words'; text.setAttribute('aria-label', 'Tell us in a few words');
      box.appendChild(sel); box.appendChild(text);
      var send = button('Send', '', function () {
        var reason = sel.value === 'Something else' ? 'Something else: ' + text.value.trim() : sel.value;
        send.disabled = true;
        if (current && current.demo) { close(); return resultMessage('Thank you. (Sample portrait: "' + reason + '" was not sent.)'); }
        api('/api/feedback', { id: id, reason: reason }).then(function () {
          close(); resultMessage('Thank you. We read every note.', [['Upload another photo', '', newPhoto]]);
        }).catch(function (e) { close(); resultMessage(e.message); });
      });
      send.disabled = true;
      sel.addEventListener('change', function () {
        text.hidden = sel.value !== 'Something else';
        if (!text.hidden) text.focus();
        send.disabled = !sel.value || (sel.value === 'Something else' && !text.value.trim());
      });
      text.addEventListener('input', function () { send.disabled = !text.value.trim(); });
      actions.appendChild(send);
      actions.appendChild(button('Cancel', 'btn-line', close));
    });
  }

  // The lens: full screen, tap to zoom in on the face, tap again or the close button to leave.
  function zoom(src) {
    var overlay = el('div', 'lab-zoom'); overlay.setAttribute('role', 'dialog'); overlay.setAttribute('aria-label', 'Portrait close-up');
    var img = el('img'); img.src = src; img.alt = 'Portrait close-up';
    var close = button('Close', 'btn-sm', function () { overlay.remove(); });
    img.addEventListener('click', function () {
      overlay.classList.toggle('in');
      if (overlay.classList.contains('in')) overlay.scrollTo((img.scrollWidth - overlay.clientWidth) / 2, 0);
    });
    overlay.appendChild(img); overlay.appendChild(close);
    document.body.appendChild(overlay);
  }
  // A portrait opened from the follow-up emails (Giacomo, 19/10/2026): ?portrait=<session>.<task> opens it with the
  // print choice already in front, on any device and without signing in. The link is the key: the two ids are
  // random UUIDs. Back from the print choice lands on the portrait, as in the normal flow. A '~' between them is read
  // too (the first test emails): Shopify rewrites it to %7E on the way in.
  function openFromLink() {
    var m = location.search.match(/[?&]portrait=([\w-]{8,})(?:\.|~|%7E)([\w-]{8,})/i);
    if (!m) return false;
    // src=email-<mode>-<step> (set by the Worker's click link): the server writes the visit in the session's history.
    var src = (location.search.match(/[?&]src=(email-(?:live|test)-[12])\b/) || [])[1];
    api('/api/status?id=' + encodeURIComponent(m[1]) + '&task=' + encodeURIComponent(m[2]) + (src ? '&src=' + src : '')).then(function (s) {
      if (s.status !== 'done') throw new Error('gone');
      var v = { id: m[1], task: m[2], template: s.template, at: new Date().toISOString(), preview: s.preview };
      if (versions.some(function (o) { return o.task === v.task; })) previews[v.task] = s.preview; else addVersion(v);
      track('email_portrait_open');
      showResult(v);
      pick(v);
    }).catch(function () {
      modal('This portrait has expired', 'We keep portraits for 30 days. Upload the photo again to make a new one: it takes a minute.', function (box, actions, close) {
        actions.appendChild(button('Make a new portrait', '', function () { close(); newPhoto(); }));
      });
    });
    return true;
  }
  renderVersions();
  if (!openFromLink()) resumePending();
})();

// ---------- lab-only tools: stand-ins for Shopify's sign-out and paid order ----------
(function () {
  'use strict';
  var bar = document.getElementById('lab-tools');
  if (!bar) return;
  function store(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function call(path, body) {
    var h = { 'x-lab-key': window.LAB.key, 'Content-Type': 'application/json' };
    try { h['x-visitor'] = localStorage.getItem('hq-visitor') || ''; var s = localStorage.getItem('hq-session'); if (s) h['x-session'] = s; } catch (e) {}
    return fetch(window.LAB.api + path, { method: 'POST', headers: h, body: JSON.stringify(body || {}) }).then(function (r) { return r.json(); });
  }
  bar.querySelector('[data-tool=order]').addEventListener('click', function () {
    call('/api/test/order').then(function (r) { alert(r.error ? r.error : 'Order paid (simulated). Portraits available: ' + r.credits + '.'); location.reload(); });
  });
  bar.querySelector('[data-tool=logout]').addEventListener('click', function () { store('hq-session', null); location.reload(); });
  bar.querySelector('[data-tool=visitor]').addEventListener('click', function () { store('hq-session', null); store('hq-visitor', null); location.reload(); });
  var demo = bar.querySelector('[data-tool=demo]');
  if (demo) demo.addEventListener('click', function () { window.HqView.demo(); });
  if (location.hash === '#demo') setTimeout(window.HqView.demo, 300);
})();
